import { render } from "./ContentInfoComponent.vue?vue&type=template&id=2f9ef6f8&scoped=true"
import script from "./ContentInfoComponent.vue?vue&type=script&lang=js"
export * from "./ContentInfoComponent.vue?vue&type=script&lang=js"

import "./ContentInfoComponent.vue?vue&type=style&index=0&id=2f9ef6f8&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9ef6f8"]])

export default __exports__